:host {
  width: 100%;
  height: 100%;
}

.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .form-wrapper {
      min-width: 500px;
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding-left: calc(var(--spacer) * 5);
      padding-right: var(--spacer);
      padding-bottom: calc(var(--spacer) * 2);
    }

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--chart-101-pressed-dividers);

      padding-left: calc(var(--spacer) * 2);
      padding-right: calc(var(--spacer) * 2);

      gz-button {
        margin-right: calc(var(--spacer) * 2);
      }
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  color: var(--secondary-color);
}

.form-subtitle + .form-section {
  margin-top: calc(var(--spacer) * 2.5);
}

gz-package-security-server-assignment-grid {
  height: 616px;
  width: 958px;
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 870px;
}

.info-box-style::part(container) {
  padding: unset;
  width: 870px;
}
